import { FC } from "react";
import { Flex } from "@chakra-ui/react";

import { CheckIcon } from "@shared/components/Icons";

const CaseDocumentDoneIcon: FC = () => (
  <Flex align="center" justify="center" flexShrink={0} boxSize="40px" borderRadius="full" bg="score.highBg">
    <CheckIcon boxSize={5} color="score.highText" />
  </Flex>
);

export default CaseDocumentDoneIcon;
